import { I18n } from '@calendly/i18n'
import { HideIcon, ViewIcon } from '@calendly/ui/components/icons'
import { Item } from '@calendly/ui/components/menu'

export const ToggleVisibilityItem = ({ isPublic, onToggle }) => (
  <Item onClick={() => onToggle(!isPublic)}>
    {
      isPublic
        ? (
          <>
            <HideIcon />
            {I18n.t('publisher.event_type_editor.header.settings.visibility.make_secret')}
          </>
        )
        : (
          <>
            <ViewIcon />
            {I18n.t('publisher.event_type_editor.header.settings.visibility.make_public')}
          </>
        )
    }
  </Item>
)
